import { render, staticRenderFns } from "./RoleEdit.vue?vue&type=template&id=56df42ce&scoped=true"
import script from "./RoleEdit.vue?vue&type=script&lang=ts"
export * from "./RoleEdit.vue?vue&type=script&lang=ts"
import style0 from "./RoleEdit.vue?vue&type=style&index=0&id=56df42ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56df42ce",
  null
  
)

export default component.exports